export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="px-6 md:px-8 py-14 md:py-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="text-xl font-heading">红桃影院</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              红桃影院是国内领先的综艺在线观看平台，提供热门综艺、真人秀免费看、
              最新综艺、搞笑综艺等高清在线观看服务。综艺大全每日更新，高清流畅不缓冲，每日欢乐不停。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">综艺专题合集</a>
              <a href="#ranking" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">综艺热榜</a>
              <a href="#carousel" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">重磅推荐</a>
              <a href="#cards" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">精选综艺</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">综艺分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">搞笑综艺</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">真人秀</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">脱口秀</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">音乐综艺</a>
              <a href="#index" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">推理综艺</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="flex gap-3 mt-4">
              <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center cursor-pointer hover:bg-white/20 transition-colors">
                <i className="ri-wechat-line text-white/70"></i>
              </span>
              <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center cursor-pointer hover:bg-white/20 transition-colors">
                <i className="ri-weibo-line text-white/70"></i>
              </span>
              <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center cursor-pointer hover:bg-white/20 transition-colors">
                <i className="ri-bilibili-line text-white/70"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2019-2026 红桃影院 · 综艺在线观看 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-white/40">
            <span className="whitespace-nowrap">热门综艺 · 真人秀免费看 · 最新综艺</span>
          </div>
        </div>
      </div>
    </footer>
  );
}